export { default } from './LinkHighlighted';